import { fork } from 'redux-saga/effects';

import { appInitSaga, wsErrorSaga } from './sagas/app-init-saga';
import { setSettingsSaga } from './sagas/set-settings-saga';
import { queueStatusSaga } from './sagas/queue-status-saga';
import { wsRequestSaga } from './sagas/ws-request-saga';
import { handleQueueCloseSaga } from './sagas/handle-queue-close-saga';
import { handleQueueOpenSaga } from './sagas/handle-queue-open-saga';
import { appErrorSaga } from './sagas/app-error-saga';
import { ticketChangesSaga } from './sagas/ticket-changes-saga';
import { providerMessageSaga } from './sagas/provider-message-saga';
import { saveQueueSettingsSaga } from './sagas/save-queue-settings-saga';
import { authErrorSaga } from './sagas/auth-error-saga';
import { handleDeviceConnectResponseSaga } from './sagas/handle-device-connect-response';
import { setBoothStatusSaga } from './sagas/set-booth-status-saga';

//import * as fakeAPI from './api/fakeAPI';

export default function* rootSaga() {
  // eslint-disable-next-line no-useless-catch
  try {
    yield fork(appInitSaga);
    yield fork(wsErrorSaga);
    yield fork(queueStatusSaga);
    yield fork(wsRequestSaga);
    yield fork(handleQueueCloseSaga);
    yield fork(handleQueueOpenSaga);
    yield fork(setSettingsSaga);
    yield fork(appErrorSaga);
    yield fork(ticketChangesSaga);
    yield fork(providerMessageSaga);
    yield fork(saveQueueSettingsSaga);
    yield fork(authErrorSaga);
    yield fork(handleDeviceConnectResponseSaga);
    yield fork(setBoothStatusSaga);

    //FIXME this is fake api support
    //yield fork(fakeAPI.watchWSOpen);
    //yield fork(fakeAPI.watchAgendaRequested);
  } catch (e) {
    throw e;
  }
}
